module.exports = __webpack_public_path__ + "static/media/so_mi_mind_map2.6af70a68.png";